import * as React from "react";

type ConfidenceControlProps = {
  displayed: boolean;
  confidenceThreshold: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

function ConfidenceControl({ displayed, confidenceThreshold, onChange }: ConfidenceControlProps) {
  if (!displayed) {
    return null;
  }

  return (
    <li>
      <div>Confidence:</div>
      <span>{confidenceThreshold}</span>
      <input
        title={`Ai regions min confidence: ${confidenceThreshold}`}
        type="range"
        min="0"
        max="100"
        value={String(confidenceThreshold)}
        onChange={onChange}
      />
    </li>
  );
}

export default ConfidenceControl;
